import type { ButtonHTMLAttributes, ReactNode } from 'react'

import { buttonClass, type ButtonSize, type ButtonVariant } from './button-style'

/**
 * 按钮。外观 100% 按 packages/tokens 手写，不引组件库。
 *
 * 外观在 `button-style.ts`，因为长得像按钮的**链接**要用同一份
 * （导航该是 `<a>` 不是 `<button>`）。三个外观的说明也在那儿，
 * 需要「长得像按钮的链接」时从那个文件取 `buttonClass`。
 */
export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
  children?: ReactNode
}

export function Button({
  variant = 'secondary',
  size = 'md',
  className,
  type = 'button',
  ...rest
}: ButtonProps) {
  return <button type={type} className={buttonClass({ variant, size, className })} {...rest} />
}
